import { Controller } from 'stimulus'

// The Help Center search box: results (help/_search_results from
// HelpController#search) update as you type, right under the box. The URL
// keeps ?q= so a refresh or a shared link shows the same results; the form
// still submits normally without JavaScript.
const DELAY = 180

export default class extends Controller {
  static targets = ['input', 'results']

  search() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.load(), DELAY)
  }

  submit(event) {
    event.preventDefault()
    clearTimeout(this.timer)
    this.load()
  }

  load() {
    const query = this.inputTarget.value.trim()
    if (query === this.lastQuery) return
    this.lastQuery = query
    this.remember(query)

    if (this.request) this.request.abort()
    if (!query) {
      this.resultsTarget.innerHTML = ''
      return
    }

    this.request = new AbortController()
    const url = new URL(this.data.get('url'), window.location.origin)
    url.searchParams.set('q', query)

    fetch(url, { credentials: 'same-origin', signal: this.request.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(response => {
        if (!response.ok) throw new Error(`Search failed: ${response.status}`)
        return response.text()
      })
      .then(html => { this.resultsTarget.innerHTML = html })
      .catch(error => {
        if (error.name === 'AbortError') return
        this.lastQuery = null
        this.resultsTarget.innerHTML = '<div class="bg-white shadow rounded-lg help-results"><p class="help-results-empty">Search didn\'t respond. Press Search to try again.</p></div>'
      })
  }

  remember(query) {
    const url = new URL(window.location.href)
    if (query) url.searchParams.set('q', query)
    else url.searchParams.delete('q')
    window.history.replaceState(window.history.state, '', url)
  }
}
